import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {baseUrl} from '../Univ.js';
function ExpiryList() {
    const [pharmviewData, setpharmviewData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        fetchpharmviewData();
    }, []);
    function fetchpharmviewData() {
        setIsLoading(true);
        axios.get(`${baseUrl}pharm-search/?totqty=gt0`)
            .then(response => {
                const today = new Date();
                const filteredData = response.data
                    .filter(item => item.totqty > 1 && item.expiry) // qty > 1 & expiry exists
                    .map(item => {
                        // Convert expiry string (DD-MM-YYYY) to Date
                        const [day, month, year] = item.expiry.split("-");
                        const expiryDate = new Date(`${year}-${month}-${day}`);
                        const diffTime = today - expiryDate;
                        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                        if (diffDays > 0) {
                            return {
                                ...item,
                                expiredDays: diffDays
                            };
                        }
                        return null;
                    })
                    .filter(item => item !== null); // remove non-expired
                setpharmviewData(filteredData);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const columns = [
        {field: 'id', headerName: 'ID', width: 50},
        {field: 'product', headerName: 'Product', width: 220},
        {field: 'batch', headerName: 'Batch', width: 100},
        {field: 'expiry', headerName: 'Expiry', width: 110},
        {
            field: 'expiredDays',
            headerName: 'Expired (Days)',
            width: 130,
        },
        {field: 'totqty', headerName: 'Tot Qty', width: 80},
        {field: 'mrp', headerName: 'MRP', width: 80},
        {
            field: 'distributor',
            headerName: 'Distributor',
            width: 150,
            renderCell: (params) => {
                return params.row.dist ? params.row.dist.name : 'Unknown';
            },
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">

                <h3 className="text-center" style={{color: 'black', backgroundColor: '#ffe6e6'}}>
                    ⚠️ Expired Drug List
                </h3>

                {!isLoading ? (
                    pharmviewData.length > 0 ? (
                        <div style={{height: '100%', width: '100%'}} className="mt-4">
                            <DataGrid
                                sx={{
                                    boxShadow: 4,
                                    border: 3,
                                    borderColor: 'red',
                                    '& .MuiDataGrid-cell:hover': {
                                        color: 'red',
                                    },
                                }}
                                rows={pharmviewData}
                                columns={columns}
                                pageSize={10}
                                slots={{toolbar: GridToolbar}}
                                autoHeight
                            />
                        </div>
                    ) : (
                        <h5 className="text-center mt-4">✅ No expired stock</h5>
                    )
                ) : (
                    <>Loading please wait...</>
                )}

            </div>
        </section>
    );
}
export default ExpiryList;